/**
 * Whether `element` is a vertical scroller of its own (overflow-y auto, scroll or overlay), rather than growing with
 * its content inside a scrolling document.
 */
export function scrollsItself( element: Element ): boolean {
    const { overflowY } = window.getComputedStyle( element );
    return overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
}

/**
 * The element a page scrolls in, for an IntersectionObserver's `root`: the layout's `<main id="main-content">` when it
 * scrolls itself (the private layout from lg), otherwise null, which means the viewport (the public layout, and the
 * private layout below lg, where the document scrolls). Rooted on the viewport while `<main>` scrolls, an observer's
 * rootMargin grows the viewport, not `<main>`, and `<main>` clips a box below its fold out of that margin, so nothing
 * mounts ahead of being scrolled to.
 *
 * Read it when the observer starts: which element scrolls depends on the layout and on the viewport width.
 */
export function getScrollRoot(): HTMLElement | null {
    if ( typeof document === 'undefined' ) {
        return null;
    }

    const main = document.getElementById( 'main-content' );
    return main && scrollsItself( main ) ? main : null;
}
